import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from 'src/util/axios-instance';
import {
  UpdateDynamicLinkRequestParams,
  UpdateDynamicLinkResponseData
} from './interfaces/updateDynamicLink.interface';

export const updateDynamicLink = async (
  params: UpdateDynamicLinkRequestParams
): Promise<UpdateDynamicLinkResponseData | undefined> => {
  const { dynamicLinkId, projectId, requestBody } = params;

  const response = await api.put<UpdateDynamicLinkResponseData>(
    `${API_URL}/v1/project/${projectId}/dynamicLinks/${dynamicLinkId}`,
    requestBody,
    { headers: { 'x-session-id': getCachedSessionId() } }
  );

  return response.data;
};
